

export const selectedSitesGetters = {
    selectedSitesFleet(state) {
        return state.selectedSitesFleet
    }
};